import { render, staticRenderFns } from "./coin-record.vue?vue&type=template&id=46ba112e&scoped=true&"
import script from "./coin-record.vue?vue&type=script&lang=js&"
export * from "./coin-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba112e",
  null
  
)

export default component.exports